import type { VehicleDetection } from "../client-messages/vehicles";
import type { SimilarFields } from "../types";

function isKnown(value: string | null | undefined): value is string {
  return !!value && value.toLowerCase() !== "unknown";
}

/**
 * Extracts core matchable fields from a vehicle detection into a SimilarFields
 * object suitable for an immediate "find similar" search.
 *
 * Deliberately omits the plate: fields are AND-ed by the search, and a plate
 * uniquely identifies a vehicle, so including it would collapse "similar" down
 * to "this exact vehicle". Similarity is make/model/colour/type only.
 *
 * Also excludes forensic attributes and load status — those produce too few
 * matches for a quick search. Users can refine with the filter panel.
 */
export function buildSimilarFields(vehicle: VehicleDetection): SimilarFields {
  const fields: SimilarFields = {};

  if (isKnown(vehicle.make)) fields.make = vehicle.make;
  if (isKnown(vehicle.model)) fields.model = vehicle.model;
  if (isKnown(vehicle.color)) fields.color = vehicle.color;
  if (isKnown(vehicle.vehicleType)) fields.types = [vehicle.vehicleType];

  return fields;
}
